import { Theme } from '@mui/material';

export const sidebarDrawerStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    py: 2,
    height: '100vh',
  },
  itemsContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
  },
  mobileContainer: {
    backgroundColor: 'var(--menu-app-bar)',
  },
  headerBoxMobile: {
    display: 'flex',
    justifyContent: 'space-between',
    px: 2,
    py: 1,
    alignItems: 'center',
  },
  listItemButtonContent: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  listItemButtonMobile: {
    padding: '8px 24px',
    transition: 'all 0.2s ease-in-out',
    '&.active': {
      color: 'primary.main',
    },
  },
  listItemIconMobile: (isActive: boolean) => ({
    color: isActive ? 'primary.main' : 'background.paper',
  }),
  listItemTextMobile: (isActive: boolean) => ({
    fontWeight: 600,
    color: isActive ? 'primary.main' : 'background.paper',
    padding: '8px 0',
  }),
  sidebarDrawerOpenIcon: (theme: Theme, sidebarOpen: boolean) => ({
    position: 'fixed',
    background: 'var(--primary)',
    color: 'background.paper',
    left: sidebarOpen ? '225px' : '59px',
    top: '25px',
    padding: 0,
    transition: theme.transitions.create('left', {
      easing: theme.transitions.easing.sharp,
      duration: sidebarOpen ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen,
    }),
    '&:hover': {
      background: 'var(--primary)',
      color: 'background.paper',
    },
  }),
  logo: {
    width: '120px',
    display: 'block',
    padding: 10,
  },
};
